import { Badge } from '@/atoms/Badge/Badge';
import { IconContainer } from '@/atoms/IconContainer/IconContainer';
import { NeedlMenuButton } from '@/atoms/Menu/RadixMenu';
import DeleteIcon from '@/icons/delete.svg?react';

type DeleteMenuType = {
  selectedItemsCount: number;
};

export const DeleteMenuButton = ({ selectedItemsCount }: DeleteMenuType) => {
  return (
    <NeedlMenuButton arrow>
      <Badge
        badgeContent={selectedItemsCount}
        variant='standard'
        color='gray'
        size='small'
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'top',
        }}
      >
        <span className='sr-only'>delete</span>
        <IconContainer className='w-6 h-6'>
          <DeleteIcon aria-hidden />
        </IconContainer>
      </Badge>
    </NeedlMenuButton>
  );
};
